import { PhoneCall, ClipboardCheck, BadgeCheck, Repeat } from "lucide-react";
import { PROCESS_STEPS } from "@/content/site";
import { Reveal } from "@/components/Reveal";

const ICONS = { PhoneCall, ClipboardCheck, BadgeCheck, Repeat };

export const Process = () => {
  return (
    <section id="jak-spoluprace-probiha" data-testid="process-section" className="py-28 md:py-36 border-t border-[#F0F0F0] bg-[#FAFAF8]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <Reveal>
          <p className="flex items-center gap-4 text-xs uppercase tracking-[0.25em] text-[#737373] font-medium">
            <span className="w-10 h-[1px] bg-[#B69A58]" aria-hidden="true" />
            Postup
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.15] text-[#252525] mt-6 max-w-2xl">
            Jak spolupráce probíhá
          </h2>
          <p className="text-base md:text-lg text-[#4A4A4A] leading-relaxed mt-6 max-w-2xl">
            Snadno, transparentně a bez zbytečného tlaku — ve čtyřech krocích.
          </p>
        </Reveal>

        <ol className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mt-16">
          <div className="hidden lg:block absolute top-7 left-0 right-0 h-px bg-[#E8E8E4]" aria-hidden="true" />
          {PROCESS_STEPS.map((step, i) => {
            const Icon = ICONS[step.icon];
            return (
              <Reveal key={step.number} delay={i * 0.07}>
                <li data-testid={`process-step-${step.number}`} className="relative h-full">
                  <span className="relative z-10 flex items-center justify-center w-14 h-14 rounded-full bg-white border border-[#E8E8E4]">
                    <Icon className="h-6 w-6 text-[#B69A58]" strokeWidth={1.25} aria-hidden="true" />
                  </span>
                  <div className="flex items-baseline gap-3 mt-6">
                    <span className="font-display text-2xl text-[#B69A58] leading-none" aria-hidden="true">
                      {step.number}
                    </span>
                    <h3 className="font-display text-xl md:text-2xl text-[#252525]">{step.title}</h3>
                  </div>
                  <p className="text-sm md:text-base text-[#4A4A4A] leading-relaxed mt-3">{step.text}</p>
                </li>
              </Reveal>
            );
          })}
        </ol>
      </div>
    </section>
  );
};
